import React, {Component} from 'react'
import {get} from 'lodash'
import {Redirect} from 'react-router-dom'
import {withStyles} from '@material-ui/core/styles/index'
import {Card, CardContent, Button, SnackbarContent} from '@material-ui/core'
import classNames from 'classnames'
import {FuseAnimate} from '@fuse'
import {Query, Mutation} from 'react-apollo'

import {USER} from '../../../graphql/query'
import {RESEND_EMAIL_VERIFICATION} from '../../../graphql/mutation'

import {logout} from '../../../utils'

const styles = _theme => ({
  root: {
    background:
      "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
    backgroundSize: 'cover',
  },
  card: {
    width: '100%',
    maxWidth: 384,
  },
})

class AuthPage extends Component {
  state = {
    resent: false,
    resenting: false,
  }

  onLogout = async () => {
    try {
      logout()
    } catch (e) {
      console.log(e)
    }
  }

  render() {
    const {classes} = this.props
    return (
      <div
        className={classNames(
          classes.root,
          'flex flex-col flex-auto flex-no-shrink items-center justify-center p-32',
        )}
      >
        <Query query={USER}>
          {({loading, error, data}) => {
            if (loading) return null
            if (!data.me) {
              return <Redirect to="/login" />
            }
            if (get(data, 'me.isEmailVerified')) {
              return <Redirect to="/projects" />
            }

            return null
          }}
        </Query>
        <div className="flex flex-col items-center justify-center w-full">
          <FuseAnimate animation="transition.expandIn">
            <Card className={classes.card}>
              <CardContent className="flex flex-col items-center justify-center p-32">
                {this.state.resent && (
                  <SnackbarContent
                    aria-describedby="client-snackbar"
                    message="Verify link has been sent. Please check the email and follow the instruction"
                  />
                )}
                <div style={{margin: '12px', textAlign: 'center'}}>
                  <div className="mb-4 font-bold">Please Verify Email</div>
                  <div>We just need to verify your email address </div>
                  <div>to complete your Deeple signup. </div>
                  <div>Please check your inbox.</div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between',
                  }}
                >
                  <Mutation mutation={RESEND_EMAIL_VERIFICATION}>
                    {(resendEmail, {loading, error}) => {
                      return (
                        <Button
                          disabled={this.state.resenting}
                          variant="contained"
                          color="secondary"
                          onClick={async e => {
                            this.setState({resenting: true})
                            await resendEmail()
                            this.setState({resent: true, resenting: false})
                          }}
                        >
                          Resend Email
                        </Button>
                      )
                    }}
                  </Mutation>
                  <Button onClick={this.onLogout}>Logout</Button>
                </div>
              </CardContent>
            </Card>
          </FuseAnimate>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, {withTheme: true})(AuthPage)



// WEBPACK FOOTER //
// ./src/main/content/login/AuthPage.js